import request from '@/utils/request'
import axios from 'axios'


//  interest_fsPage_req ,interest_gzPage_req , interest_edit_req, interest_read_req

//粉丝列表
export function interest_fsPage_req(data) {
  return request({
    url:  '/interest/fsPage',
    method: 'post',
    data: data,
  })
}

//关注列表
export function interest_gzPage_req(data) {
  return request({
    url:  '/interest/gzPage',
    method: 'post',
    data: data,
  })
}

//关注|取消关注
export function interest_edit_req(data) {
  return request({
    url:  '/interest/edit',
    method: 'post',
    data: data,
  })
}
//已读
export function interest_read_req( query ){
  return request({
    url:  '/interest/read',
    method: 'get',
    params: query,
  })
}